import type {
  SalonPublicTemplateKey,
  SalonPublicLayoutConfig,
  SalonThemeConfig,
} from './salonsApi';


interface SalonAppearanceDocumentsRequest {
  salonId: number;
  template_key: SalonPublicTemplateKey;
  theme: SalonThemeConfig;
  layout: SalonPublicLayoutConfig;
}

interface SalonAppearanceTargetsRequest {
  salonId: number;
  language?: string;
}

interface SalonAppearanceApplyRequest
  extends SalonAppearanceDocumentsRequest {
  salonIds: number[];
}

export const buildSalonAppearanceRetrieveRequest = (salonId: number) => ({
  url: `/api/salons/${salonId}/appearance/`,
});

export const buildSalonAppearanceUpdateRequest = ({
  salonId,
  template_key,
  theme,
  layout,
}: SalonAppearanceDocumentsRequest) => ({
  url: `/api/salons/${salonId}/appearance/`,
  method: 'PATCH',
  body: { template_key, theme, layout },
});

export const buildSalonAppearanceResetRequest = ({
  salonId,
  template_key,
  theme,
  layout,
}: SalonAppearanceDocumentsRequest) => ({
  url: `/api/salons/${salonId}/appearance/`,
  method: 'DELETE',
  body: { template_key, theme, layout },
});

export const buildSalonAppearanceTargetsRequest = ({
  salonId,
  language,
}: SalonAppearanceTargetsRequest) => ({
  url: `/api/salons/${salonId}/appearance/targets/`,
  params: language ? { language } : undefined,
});

export const buildSalonAppearanceApplyRequest = ({
  salonId,
  template_key,
  theme,
  layout,
  salonIds,
}: SalonAppearanceApplyRequest) => ({
  url: `/api/salons/${salonId}/appearance/apply/`,
  method: 'POST',
  body: {
    template_key,
    theme,
    layout,
    salon_ids: Array.from(new Set(salonIds)).sort(
      (left, right) => left - right
    ),
  },
});
